import actionTypes from "./actionTypes"

//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//               TRAILER                        //
//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//

export const setTrailerMovie = (trailerMovie = null) => ({
    type: actionTypes.UI_SET_TRAILER_MOVIE,
    payload: {
        trailerMovie: trailerMovie
    }
})

export const setYoutubeCookieConfirmation = (hasConfirmation = 'init') => ({
    type: actionTypes.UI_SET_YOUTUBE_COOKIE_CONFIRMATION,
    payload: {
        hasConfirmation: hasConfirmation
    }
})

//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//                ElementDisplay                //
//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//


export const setIsMobile = (key = null) => ({
    type: actionTypes.UI_SET_ISMOBILE,
    payload: {
        key: key
    }
})
    
export const setBrowserWidth = (width, theme) => ({
    type: actionTypes.UI_SET_BROWSER_WIDTH,
    payload: {
        width: width,
        theme: theme
    }
})

export const togglePerformancePage = (activePerformance, bool) => ({
    type: actionTypes.UI_SET_MOVIE_PERFORMANCE_PAGE,
    payload: {
        activePerformance: activePerformance,
        bool: bool
    }
})

export const toggleDetails = (id) => ({
    type: actionTypes.UI_SET_MOVIE_DETAILS,
    payload: {
        id: id
    }
})

export const toggleInformation = (id, movieTimesId) => ({
    type: actionTypes.UI_SET_MOVIE_INFORMATION,
    payload: {
        id: id,
        movieTimesId: movieTimesId
    }
})

export const setActiveSelection = (selectionId) => ({
    type: actionTypes.UI_SET_ACTIVE_SELECTION,
    payload: {
        selectionId: selectionId
    }
})

export const setActiveItemIndex = (index) => ({
    type: actionTypes.UI_SET_ACTIVE_ITEM_INDEX,
    payload: {
        index: index
    }
})

export const toggleSidebars = (side, int, bool) => ({
    type: actionTypes.UI_TOGGLE_SIDEBARS,
    payload: {
        side: side,
        int: int,
        bool: bool
    }
})

//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//               USERBAR                        //
//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//

export const setActiveUserContent = (activeUserContent = '') => ({
    type: actionTypes.UI_SET_ACTIVE_USER_CONTENT,
    payload: {
        activeUserContent: activeUserContent
    }
})

export const setIsLoggedIn = (isLoggedIn = false) => ({
    type: actionTypes.UI_SET_LOGGED_IN,
    payload: {
        isLoggedIn: isLoggedIn
    }
})